/** @jsx jsx */
import { jsx } from '@emotion/core';
import { Text } from '@sitecore-jss/sitecore-jss-react';
import defaultsDeep from 'lodash/defaultsDeep';
import { Container, Row, Column } from '../../../../styles/Grid';
import DotComponent from '../../../ui/DotComponent';
import { SafePureComponent } from '../../../../utils/SafePureComponent';
import Spacer from '../../../ui/Spacer';
import SolutionsDropdown from './SolutionsDropdown';
import FilterButtons from './FilterButtons';
import Search from './Search';
import * as styles from './index.styles';

export const defaultData = {
  BackgroundColor: { fields: { Value: { value: '' } } },
  FilterBySolution: [],
  Headline: {
    value: '',
  },
};

class Hero extends SafePureComponent {
  safeRender() {
    const fields = defaultsDeep(this.props.fields, defaultData);
    const { BackgroundColor, Filters, Headline } = fields;
    const { Solutions } = Filters;

    return (
      <Spacer
        marginCss={styles.spacerMargin}
        paddingCss={styles.spacerPadding}
        backgroundColor={BackgroundColor}
      >
        <Container>
          <Row>
            <Column cols={{ sm: 6, md: 8, lg: 12 }}>
              <h1 css={styles.heroTitle}>
                <SolutionsDropdown fields={Solutions} />
                <Text field={Headline} />
                <DotComponent />
              </h1>
            </Column>
          </Row>
          <Row css={styles.aligner}>
            <Search />
            <FilterButtons fields={{ Filters }} />
          </Row>
        </Container>
      </Spacer>
    );
  }
}

export default Hero;
